import { render } from "./User_Detail.vue?vue&type=template&id=2d0a1474"
import script from "./User_Detail.vue?vue&type=script&lang=js"
export * from "./User_Detail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__